import { useMemo, useState } from "react";
import { Briefcase } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { MOCK_CASE_NUMBERS } from "@/components/case_portal/mockCases";
import { useCasePortal } from "@/context/CasePortalContext";

export function CaseHistoryList() {
  const { activeCaseNumber, openCase } = useCasePortal();
  const [search, setSearch] = useState("");

  const filteredCases = useMemo(() => {
    const searchLower = search.trim().toLowerCase();
    if (searchLower.length === 0) return [...MOCK_CASE_NUMBERS];
    return MOCK_CASE_NUMBERS.filter((caseNumber) =>
      caseNumber.toLowerCase().includes(searchLower)
    );
  }, [search]);

  return (
    <div className="w-full max-w-[236px]">
      <div className="py-2 pl-3 pr-[10px]">
        <input
          type="text"
          placeholder="Search cases..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full rounded-md border border-input bg-input px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus:ring-1 focus:ring-ring transition-colors"
        />
      </div>
      <div className="py-2" role="list" aria-label="Case history list">
        {filteredCases.map((caseNumber) => {
          const isActive = activeCaseNumber === caseNumber;
          return (
            <Button
              key={caseNumber}
              variant={isActive ? "secondary" : "ghost"}
              className={cn("h-9 w-full justify-start px-3 py-0", isActive && "border-2 border-primary font-medium")}
              onClick={() => openCase(caseNumber)}
              role="listitem"
            >
              <Briefcase className={cn("h-4 w-4 shrink-0", isActive && "text-primary")} />
              <span className="ml-2 overflow-hidden text-ellipsis max-w-[180px]">
                {caseNumber}
              </span>
            </Button>
          );
        })}

        {filteredCases.length === 0 && (
          <div className="text-xs text-muted-foreground italic">No cases found</div>
        )}
      </div>
    </div>
  );
}

